@if (showActivationNotice) {
  <div>
    <div class="tw-mb-1">
      <notification-alert id="activation-notice" type="info">
        @if (isFirstDisplay) {
          <strong>You&rsquo;ve activated your first display!</strong>
        } @else {
          <strong>Your display is activated.</strong>
        }
        @if (showAddScheduleNotice) {
          <div>Select a schedule to start showing content.</div>
        }
        @if (showAddPresentationNotice) {
          <div>Start showing content by creating your first presentation.</div>
        }
      </notification-alert>
    </div>
    <button
      rv-button
      class="w-100 mt-3 mb-2"
      [shown]="showAddPresentationNotice"
      (click)="navigateToCreatePresentation()"
    >
      Create Presentation
    </button>
  </div>
}
